var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "-->\n", /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1311_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 229C93.8443 229 66 186.635 66 134.5C66 82.3646 93.8443 40 128 40C162.156 40 190 82.3646 190 134.5C190 186.635 162.156 229 128 229ZM128 45.0718C96.5916 45.0718 71.0491 85.1989 71.0491 134.5C71.0491 183.801 96.5916 223.928 128 223.928C159.408 223.928 184.951 183.801 184.951 134.5C184.951 85.1989 159.408 45.0718 128 45.0718Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.515 76.2486C114.635 76.2486 101.269 74.6823 87.7557 70.1326C86.4192 69.6851 85.7509 68.268 86.1964 66.9254C86.6419 65.5829 88.0527 64.9116 89.3892 65.3591C128.297 78.4862 167.279 65.0608 167.725 64.9116C169.061 64.4641 170.472 65.1354 170.917 66.4779C171.363 67.8205 170.695 69.2376 169.358 69.6851C168.244 70.058 150.35 76.2486 126.515 76.2486Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7809 194.914C82.7809 194.914 82.1868 194.914 81.9641 194.765C80.6276 194.318 79.9593 192.826 80.4791 191.558L89.018 167.84V101.16L79.588 77.3674C79.0683 76.0994 79.7365 74.6077 80.9988 74.0856C82.2611 73.5635 83.7461 74.2348 84.2659 75.5027L93.8443 99.7431C93.8443 99.7431 93.9928 100.34 93.9928 100.713V168.287C93.9928 168.287 93.9928 168.884 93.8443 169.182L85.1569 193.348C84.7856 194.392 83.8204 194.989 82.7809 194.989V194.914Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8611 117.345C69.0443 117.345 68.3018 116.972 67.782 116.227C66.9653 115.108 67.2623 113.541 68.4503 112.721L88.9437 98.4006L126.292 41.1188C127.035 39.9254 128.594 39.6271 129.782 40.3729C130.97 41.1188 131.267 42.6851 130.525 43.8785L92.879 101.608C92.879 101.608 92.5078 102.13 92.2108 102.279L71.3461 116.823C70.9006 117.122 70.3808 117.271 69.9353 117.271L69.8611 117.345Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.322 117.345C184.802 117.345 184.357 117.196 183.911 116.898L163.047 102.354C163.047 102.354 162.527 101.906 162.378 101.682L124.733 43.8785C123.99 42.6851 124.287 41.1188 125.475 40.3729C126.663 39.6271 128.223 39.9254 128.965 41.1188L166.314 98.4752L186.807 112.796C187.921 113.616 188.218 115.182 187.475 116.301C186.956 116.972 186.213 117.42 185.396 117.42L185.322 117.345Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.629 229C127.183 229 126.663 228.851 126.218 228.552C125.03 227.807 124.733 226.24 125.475 225.047L163.121 167.318C163.121 167.318 163.492 166.796 163.789 166.646L184.654 152.102C185.768 151.282 187.327 151.58 188.144 152.773C188.96 153.892 188.663 155.459 187.475 156.279L166.982 170.599L129.634 227.956C129.114 228.702 128.371 229.075 127.554 229.075L127.629 229Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.188 229C128.371 229 127.554 228.627 127.109 227.881L89.7605 170.525L69.2671 156.204C68.1533 155.384 67.8563 153.818 68.5988 152.699C69.4156 151.58 70.9748 151.282 72.0886 152.028L92.9533 166.572C92.9533 166.572 93.4731 167.019 93.6216 167.243L131.267 224.972C132.01 226.166 131.713 227.732 130.525 228.478C130.079 228.776 129.634 228.925 129.114 228.925L129.188 229Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.878 201.776C169.878 201.776 169.358 201.776 169.061 201.627C130.079 188.5 89.6862 201.478 89.3149 201.627C87.9784 202.075 86.5676 201.329 86.1221 199.986C85.6766 198.644 86.4191 197.227 87.7557 196.779C89.4635 196.182 130.079 183.055 170.695 196.779C172.031 197.227 172.699 198.644 172.254 199.986C171.883 201.03 170.917 201.702 169.878 201.702V201.776Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.442 195.735C172.402 195.735 171.363 195.064 171.066 194.019L163.121 169.257C163.121 169.257 162.972 168.809 162.972 168.511L161.636 99.5939C161.636 99.5939 161.636 98.9226 161.784 98.6243L171.289 74.6077C171.808 73.3398 173.293 72.6685 174.556 73.1906C175.818 73.7127 176.486 75.2044 175.966 76.4724L166.685 100.041L168.022 168.064L175.892 192.453C176.338 193.796 175.595 195.213 174.259 195.66C174.036 195.735 173.739 195.809 173.516 195.809L173.442 195.735Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1311_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 189,
    fill: "white",
    transform: "translate(66 40)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/Oval.8f1400ac713d9d1db6d2c1ba04728441.svg";
export { ForwardRef as ReactComponent };